import React from "react";
import { useTranslation } from "react-i18next";

import { legendItemStyle, legendStyle } from "../style";
import { seismicGreenShades } from "../../util/MapUtils";

export const climateIndexLevelNames = (t) => [
  t("levels.veryLow"),
  t("levels.relativelyLow"),
  t("levels.relativelyModerate"),
  t("levels.moderate"),
  t("levels.relativelyHigh"),
  t("levels.high"),
  t("levels.veryHigh"),
];

export const SeismicTIVRiskLegend = ({
  customLegendStyle = legendStyle,
  title,
  indexValues = [10, 33, 100, 330, 600, 9999],
  detailsTxt,
}) => {
  const { t } = useTranslation();

  return (
    <div style={customLegendStyle}>
      <div>
        <b>{title} </b>
      </div>
      <div>
        <span style={legendItemStyle(seismicGreenShades[0])}></span>
        {climateIndexLevelNames(t)[0]}:index &lt; {indexValues[0]}
      </div>
      <div>
        <span style={legendItemStyle(seismicGreenShades[1])}></span>
        {climateIndexLevelNames(t)[1]}: {indexValues[0]} &le; index &lt; {indexValues[1]}
      </div>
      <div>
        <span style={legendItemStyle(seismicGreenShades[2])}></span>
        {climateIndexLevelNames(t)[2]}: {indexValues[1]} &le; index &lt; {indexValues[2]}
      </div>
      <div>
        <span style={legendItemStyle(seismicGreenShades[3])}></span>
        {climateIndexLevelNames(t)[3]}: {indexValues[2]} &le; index &le; {indexValues[3]}
      </div>
      <div>
        <span style={legendItemStyle(seismicGreenShades[4])}></span>
        {climateIndexLevelNames(t)[4]}: {indexValues[3]} &le; index &le; {indexValues[4]}
      </div>
      <div>
        <span style={legendItemStyle(seismicGreenShades[5])}></span>
        {climateIndexLevelNames(t)[5]}: {indexValues[4]} &le; index &le; {indexValues[5]}
      </div>
      <div>
        <span style={legendItemStyle(seismicGreenShades[6])}></span>
        {climateIndexLevelNames(t)[6]}: index &gt; {indexValues[5]}
      </div>

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          {detailsTxt}
        </span>
      </div>
    </div>
  );
};
